import axios from 'axios';
import { EVERY_MINUTE } from '../../constants';
import type { NetworkDetails } from './types';

interface IpApiResponse {
    ip: string;
    org: string;
}

interface NetworkDetailsCache {
    data: NetworkDetails;
    timestamp: number;
}

const CACHE_KEY = 'moniebook-register:network_details';
const CACHE_TTL_MS = 360 * EVERY_MINUTE;

function readCache(): NetworkDetails | null {
    try {
        const raw = localStorage.getItem(CACHE_KEY);
        if (!raw) return null;

        const { data, timestamp }: NetworkDetailsCache = JSON.parse(raw);

        if (Date.now() - timestamp < CACHE_TTL_MS) return data;
    } catch {
        // ignore parse errors or missing localStorage
    }
    return null;
}

function writeCache(data: NetworkDetails): void {
    try {
        const entry: NetworkDetailsCache = { data, timestamp: Date.now() };
        localStorage.setItem(CACHE_KEY, JSON.stringify(entry));
    } catch {
        // ignore storage full or unavailable
    }
}

let inFlight: Promise<NetworkDetails> | null = null;

export async function getNetworkDetails(): Promise<NetworkDetails> {
    const cached = readCache();
    if (cached) return cached;

    if (inFlight) return inFlight;

    inFlight = axios
        .get<IpApiResponse>('https://ipapi.co/json')
        .then((response) => {
            const data: NetworkDetails = {
                ip: response.data.ip,
                name: response.data.org,
                type: 'wifi',
            };
            writeCache(data);
            return data;
        })
        .finally(() => {
            inFlight = null;
        });

    return inFlight;
}
